<template>
  <div class="line-progress">
    <span :style="computedTotalStyle"></span>
    <span :style="computedCurrentStyle"></span>
  </div>
</template>

<script>
export default {
  name: 'commonProgressLine',
  components: {},
  props: {
    total: {
      type: Number,
      default: 0
    },
    current: {
      type: Number,
      default: 0
    },
    totalColor: {
      type: String,
      default: '#dfdfe0'
    },
    currentColor: {
      type: String,
      default: '#006AFE'
    },
    lineWidth: {
      // 进度条宽度
      type: Number,
      default: 8
    }
  },
  data() {
    return {}
  },
  computed: {
    computedProgress() {
      let _progress = 0
      if (!this.total) {
        _progress = 100
      } else {
        _progress = Math.ceil((this.current * 1000) / this.total) / 10
      }
      return _progress
    },
    computedTotalStyle() {
      let _style = {}
      _style.height = `${this.lineWidth}px`
      let _color = this.totalColor.split(',')
      if (_color.length > 1) {
        _style.background = _color[0]
        _style.opacity = _color[1]
      } else {
        _style.background = this.totalColor
      }
      return _style
    },
    computedCurrentStyle() {
      let _style = {}
      _style.width = `${this.computedProgress}%`
      _style.height = `${this.lineWidth}px`
      _style.background = this.currentColor
      return _style
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
  filters: {}
}
</script>

<style lang="scss" scoped>
.line-progress {
  width: 100%;
  position: relative;
  > span {
    display: inline-block;
    width: 100%;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    border-radius: 4px;
  }
}
</style>
